// ======================================================================
// File Name       : ContentDocumentDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Redirect } from 'react-router-dom';
import * as ContentDocumentAction from '../../actions/content/ContentDocumentAction';
import ContentDocumentDetail from '../../components/content/ContentDocumentDetail';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import { DOCUMENT_EDIT_TYPE, DOC_ACCEPT_FILE } from '../../constants/ContentConstant';
import { CONTENT_DOCUMENT_EDIT } from '../../constants/FunctionConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { getFileExtension } from '../../utils/ContentUtils';
import { shouldHideBackBtn } from '../../utils/index';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ContentDocumentDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentContentInfo: {
        contentSecernId: '',
        contentName: '',
        documentUpdateStatus: '',
        imageUrl: '',
        documentName: '',
        createdAt: '',
        updatedAt: '',
        noRecordFound: false,
      },
      editSuccess: false,
      showModal: false,
    };
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteOk = this.onDeleteOk.bind(this);
    this.deleteDocumentDetail = this.deleteDocumentDetail.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.getDocumentDetail(match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    const { documentContentInfo, editSuccess } = nextProps;
    this.setState({
      documentContentInfo,
      editSuccess,
    });
  }

  getDocumentDetail(contentSecernId) {
    if (contentSecernId) {
      const params = {};
      params.selectTargetData = 0;
      params.searchInfo = {
        contentSecernIdList: [contentSecernId],
      };
      this.props.dispatch(ContentDocumentAction.getDocumentDetail(params));
    } else {
      this.setState({
        ...this.state.documentContentInfo,
        noRecordFound: true,
      });
    }
  }

  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
   * Event click button cancel of delete confirm dialog
   */
  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  /**
   * Event click button ok of delete confirm dialog
   */
  onDeleteOk() {
    this.setState({ showModal: false });
    this.deleteDocumentDetail();
  }

  deleteDocumentDetail() {
    const { documentContentInfo } = this.state;
    if (documentContentInfo && documentContentInfo.contentSecernId) {
      const params = {};
      params.editType = DOCUMENT_EDIT_TYPE.DELETE;
      const documentDetail = {};
      documentDetail.contentSecernId = documentContentInfo.contentSecernId;
      params.documentContentInfo = documentDetail;
      this.props.dispatch(ContentDocumentAction.editDocumentDetail(params));
    }
  }

  downloadDocument(fileName) {
    const { documentContentInfo } = this.state;
    const { contentSecernId } = documentContentInfo;
    if (contentSecernId) {
      const fileType = getFileExtension(fileName).toLowerCase();
      const documentDownloadType = DOC_ACCEPT_FILE.split(',').indexOf(fileType);

      const params = {
        contentSecernId,
        documentDownloadType,
      };
      this.props.dispatch(ContentDocumentAction.downloadDocument(params));
    }
  }

  render() {
    const { documentContentInfo, editSuccess } = this.state;
    const link = Path.CONTENT_DOCUMENT_LIST;
    const id = this.props.match.params.id;
    const to = `/content/document/${id}/edit`;
    const showBackBtn = !shouldHideBackBtn(this.props.location);
    if (!documentContentInfo || documentContentInfo.noRecordFound || editSuccess) {
      return <Redirect to={link} />;
    }
    const canAccess = canAccessRoute(CONTENT_DOCUMENT_EDIT);
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DOCUMENT_LIST}
          text="ドキュメント一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ドキュメントの詳細" />
        <ContentDocumentDetail
          {...this.state.documentContentInfo}
          downloadDocument={this.downloadDocument}
          isDetail
        />
        <Col sm={12} className="text-center margin-top-20">
          {documentContentInfo &&
          !documentContentInfo.dataAffiliationType &&
          canAccess ?
            <LinkContainer to={to} className="btn-96 margin-10">
              <Button
                variant="primary"
                className="btn-96 margin-10"
              >
                編集
              </Button>
            </LinkContainer> : null}
          {documentContentInfo &&
          !documentContentInfo.dataAffiliationType &&
          canAccess ?
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.openDeleteConfirmDialog.bind(this, MessageTemplate.MSG_DEL_DOC, null)}
            >
            削除
          </Button> : null}
        </Col>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { documentContentInfo, editSuccess } = state.document;
  return { ...{ documentContentInfo, editSuccess } };
};

export default connect(mapStateToProps)(ContentDocumentDetailContainer);
